module.exports = __webpack_public_path__ + "2fdb52c8d42367089db0659c452c0d45.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./docs/karte_festival.jpg
// module id = 596
// module chunks = 0